"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { Region } from "@/shared/config/constants";

type RegionState = {
  selectedRegion: Region | null;
  setSelectedRegion: (region: Region | null) => void;
};

export const DEFAULT_REGION: Region = "tashkent";

export const useRegionStore = create<RegionState>()(
  persist(
    (set) => ({
      selectedRegion: DEFAULT_REGION,
      setSelectedRegion: (region) => set({ selectedRegion: region }),
    }),
    {
      name: "selected-region-v1",
    },
  ),
);
